import { useState } from 'react';
import { Search, BookOpen, Loader2, Check, X } from 'lucide-react';

export function SkillList({ skills, loading, selectedId, onSelect }) {
  const [search, setSearch] = useState('');

  const filtered = skills.filter(s =>
    !search || s.name.toLowerCase().includes(search.toLowerCase()) ||
    (s.description || '').toLowerCase().includes(search.toLowerCase())
  );

  const categories = [...new Set(skills.map(s => s.category).filter(Boolean))];

  return (
    <div className="w-64 bg-gray-900 border-r border-gray-800 flex flex-col overflow-hidden">
      {/* Search */}
      <div className="p-3">
        <div className="relative">
          <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-gray-500" />
          <input
            type="text"
            value={search}
            onChange={e => setSearch(e.target.value)}
            placeholder="Search skills..."
            className="w-full bg-gray-800/60 border border-gray-700/50 rounded-lg pl-8 pr-3 py-1.5 text-xs text-gray-200 placeholder-gray-500 focus:outline-none focus:border-gray-600"
          />
        </div>
      </div>

      {/* List */}
      <div className="flex-1 overflow-y-auto px-2 pb-2">
        {loading ? (
          <div className="flex justify-center py-8">
            <Loader2 className="h-4 w-4 animate-spin text-gray-600" />
          </div>
        ) : filtered.length === 0 ? (
          <div className="text-center text-gray-600 text-xs mt-6">
            {search ? 'No matches' : 'No skills yet'}
          </div>
        ) : (
          filtered.map(skill => (
            <button
              key={skill.id}
              onClick={() => onSelect(skill)}
              className={`w-full text-left px-3 py-2.5 rounded-lg mb-0.5 transition-colors ${
                selectedId === skill.id
                  ? 'bg-violet-500/10 border border-violet-500/20'
                  : 'hover:bg-gray-800/50 border border-transparent'
              }`}
            >
              <div className="flex items-center gap-2">
                <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${skill.is_active ? 'bg-emerald-400' : 'bg-gray-600'}`} />
                <span className={`text-sm font-medium truncate ${selectedId === skill.id ? 'text-violet-300' : 'text-gray-200'}`}>
                  {skill.name}
                </span>
              </div>
              <p className="text-[11px] text-gray-500 mt-0.5 line-clamp-2 ml-3.5">
                {skill.description}
              </p>
              {skill.category && (
                <span className="inline-block mt-1 ml-3.5 text-[10px] text-gray-600 bg-gray-800 px-1.5 py-0.5 rounded">
                  {skill.category}
                </span>
              )}
            </button>
          ))
        )}
      </div>
    </div>
  );
}
